import { render, staticRenderFns } from "./StockStores.vue?vue&type=template&id=746bb0fe&scoped=true&"
import script from "./StockStores.vue?vue&type=script&lang=js&"
export * from "./StockStores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746bb0fe",
  null
  
)

export default component.exports